module.exports = __webpack_public_path__ + "img/tree-04-f-trunk.68b6239f.png";